import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import { getWidgetFieldDatatypeOptions } from '../../../../expressions/datatype/getWidgetFieldDatatypeOptions.ts';
import {
  type IReference,
  ReferenceType,
} from '../../../../expressions/references/IReference.ts';
import {
  type IReferencePath,
  ReferencePathDirection,
} from '../../../../expressions/references/IReferencePath.ts';
import { WidgetType } from '../../../Widget.ts';
import { isWidgetOptionValue } from '../common/option-list/isWidgetOptionValue.ts';
import { multiSelectOptionsObjectName } from './getMultiSelectOptionsObjectName.ts';
import { type IMultiSelectWidget } from './IMultiSelectWidget.ts';

export function getMultiSelectWidgetReference(
  path: IReferencePath,
  widget: IMultiSelectWidget,
): IReference {
  return {
    type: ReferenceType.Widget,
    widgetType: widget.type,
    path,
    id: widget.id,
    code: widget.code,
    label: widget.code,
    field: {
      type: Datatype.Array,
      itemsType: Datatype.String,
      options: getWidgetFieldDatatypeOptions(widget),
    },
  };
}

/**
 * Ritorna una lista di reference per ogni opzione del widget
 */
export function getMultiSelectWidgetOptionsReferences(
  path: IReferencePath,
  widget: IMultiSelectWidget,
): IReference[] {
  return widget.options.filter(isWidgetOptionValue).map(option => ({
    type: ReferenceType.Widget,
    widgetType: WidgetType.Boolean,
    path: [
      ...path,
      {
        direction: ReferencePathDirection.Child,
        code: multiSelectOptionsObjectName(widget.code),
      },
    ],
    id: `${widget.id}-${option.value as string}`,
    code: option.value,
    label: `${widget.code}: ${option.value as string}`,
    field: {
      type: Datatype.Boolean,
    },
  }));
}
